export default __webpack_public_path__ + "static/media/CSharp Com MVC CERT.c2bc536d.png";